import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import { FlashCardComponentHandler, FlashMessageCardComponentProps, FlashMessageCardComponentState } from "./flashmessagecardcomponent";
import { FlashMessageCardCSSStyle } from "./flashmessagecardcss";
import * as React from "react";
import { LoaderWrapperComponent } from "../../../popup/loaderwrappercomponent";
import { PopUpWrapperComponent } from "../../../popup/popupwrappercomponent";
import { DeleteConfirmComponent } from "../../../popup/deleteconfirmation/deleteconfirmationcomponent";
import { AlertType } from "../../../../toolkit/alert/alerttype";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { RoutingFeatures } from "../../../navigation/routingfeature";
import { AlertComponent } from "../../../../toolkit/alert/alertcomponent";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import './flashmessagecard-style.css';
import { SetNowButtonCSSStyleImpl } from "./flashcardbuttoncss";
import { ButtonComponent } from "../../../../toolkit/button/buttoncomponent";
import { SetNowButtonOnHoverCSSStyleImpl } from "./flashcardbuttononhovercss";

export class FlashMessageCardViewImpl extends UIComponentViewImpl<UIDataModel> 
{  
    private loaderWrapperComponent:LoaderWrapperComponent;
    private popUpComponent: PopUpWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
        this.onHovered = this.onHovered.bind(this);
        this.onHoveredExit = this.onHoveredExit.bind(this);
        this.onActionHoveredExit = this.onActionHoveredExit.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.login = this.login.bind(this);
    }

    draw(props: FlashMessageCardComponentProps, state: FlashMessageCardComponentState, cssStyle: FlashMessageCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        return (
            <>
              <div id="flash-card-wrapper">
                                {
                                    this.getWebView(props, state, cssStyle)
                                }
                    </div>
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }


    getWebView(props: FlashMessageCardComponentProps, state: FlashMessageCardComponentState, cssStyle: FlashMessageCardCSSStyle)
    {
        return (
           <>
            <div id="flash-card-main-wrapper" key={props.position} style={props.cardStyle.getToneWrapperCSSStyle(state.isHovered)} onMouseEnter={this.onHovered} onMouseLeave={this.onHoveredExit}>
                 <div id="flash-card-extra-option-web">
                           {
                                state.isHovered ? this.getFlashMessageDiv(props, state,cssStyle)
                                 :
                                 <>
                                        <div id="flash-quotes-div" style={{}}>
                                                <img id="flash-quotes-img-div"  src={this.getContext().getResources().getImage("quotes.svg")}/>
                                         </div>
                                        <div id="flash-status-div" style={{}}>
                                                      {props.flashMessageDto.getStatusMessage()}
                                        </div> 
                                            
                                        <div id="flash-setnow-button-div">
                                  
                                            <ButtonComponent onClick={() => {props.onSetNow(props.flashMessageDto);}}  style={new SetNowButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.set_now)}/>

                                        </div>  
                                 </>
                                }   
                       </div>
            </div>    
           </>     
        );
    }


    getFlashMessageDiv(props:FlashMessageCardComponentProps, state:FlashMessageCardComponentState, cssStyle:FlashMessageCardCSSStyle){
        return(
            <>
             <div id={(this.getUIProps() as FlashMessageCardComponentProps).position % 2 !== 0 ? "flash-card-onhover-even" : "flash-card-onhover-odd"} style={cssStyle.getOnHoverCSSStyle()}>
                                    <div id="flash-quotes-div-hover" style={{}}>
                                                <img  id="flash-quotes-img-div" src={this.getContext().getResources().getImage("quotes_white.svg")}/>
                                       </div>
                              <div id="flash-status-div" style={{}}>
                                                      {props.flashMessageDto.getStatusMessage()}
                                             </div> 
                                            
                              <div id="flash-setnow-button-div" style={{}}>
                                  
                                  <ButtonComponent onClick={() => {props.onSetNow(props.flashMessageDto);}}  style={new SetNowButtonOnHoverCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.set_now)}/>
                              
                              </div>
                                     
            </div>                  
            </>
        );
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    protected closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
 
    onDeleteClicked()
    {
    }
   
     showDeleteConfirmationPopUp(id: string)
     {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, 
            <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.The_tune_will_be_deleted_and_all_related_settings_will_no_longer_be_available)} id={id}  headerTitle={this.getContext().getResources().getString(Strings.confirm)} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.onDeleteConfirmed} onCancelClick={this.closePopup} />);
     }
     login()
     {
         this.closePopup();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
     }
     onDeleteConfirmed():void
     {
        (this.getUIComponentHandler() as FlashCardComponentHandler).onDeleteClicked();

     }
 
    showPopup(id:string,msg:string,type:AlertType):void
    {
        this.closePopup();
        
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
         
    }
  
    protected getPopUpWrapper():PopUpWrapperComponent
    {
        return this.popUpComponent;
    }
   
    protected onHovered(): void 
    {
        if(!(this.getUIState() as FlashMessageCardComponentState).isActionHovered)
        {
            (this.getUIComponentHandler() as FlashCardComponentHandler).onHovered();
        }
    }
 
    protected onHoveredExit(): void 
    {
        (this.getUIComponentHandler() as FlashCardComponentHandler).onHoveredExit();
    }

    protected onActionHoveredExit(): void 
    {
        (this.getUIComponentHandler() as FlashCardComponentHandler).onActionHoveredExit();
    }
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecard/flashmessagecardview.tsx